import { LandingPage } from '@/components/landing-page';
import { ThemeProvider } from '@/components/theme-provider';
import { LocaleProvider } from '@/i18n/locale-context';

export default function App() {
  return (
    <ThemeProvider>
      <LocaleProvider>
        <LandingPage />
      </LocaleProvider>
    </ThemeProvider>
  );
}
